module.exports = __webpack_public_path__ + "static/TabsHorizontalBar-0d1f5ece53316e0318e6cf6c08042306.png";